export default __webpack_public_path__ + "static/media/entrata-logo-large.abf27b8d.svg";